// extracted by mini-css-extract-plugin
export var childrenContainer = "_bm-0";
export var virtualScrollArea = "_bm-1";